import { AutocompleteItem, AutocompleteSettings } from "autocompleter";
import * as $ from "jquery";
import { Analytics } from '@plaudit/analytics';
const analytics = Analytics.getInstance();

declare function require(name: string): any;

interface PlauditAutocompleteResponse {
	suggester: string;
	results: PlauditAutocompleteOption[];
}

interface PlauditAutocompleteOption extends AutocompleteItem {
	href?: string;
	fields?: object;
}

export default function initAutocompleter() {
	let baseURI = document.baseURI;
	if (!baseURI) {
		let baseTags = document.getElementsByTagName("base");
		baseURI = baseTags.length ? baseTags[0].href : document.URL
	}
	if (baseURI.charAt(baseURI.length - 1) !== '/') {
		baseURI = baseURI + '/';
	}

	const setUpElements = (root: ParentNode): void => {
		// Grab all autocomplete input fields on a page
		const suggestionBoxes = root.querySelectorAll("input:not(.autocomplete-set-up)[data-autocomplete-suggester]");

		for (let i = 0; i < suggestionBoxes.length; i++) {
			const input = suggestionBoxes.item(i) as HTMLInputElement;
			let onSelectedValidOption: boolean = false;

			let suggester = input.getAttribute('data-autocomplete-suggester');
			const singleSuggester = suggester.indexOf(' ') === -1 && suggester.indexOf(',') === -1;

			let mostRecentSuggestionsResponse: PlauditAutocompleteResponse;
			let variantClass = input.getAttribute('data-autocomplete-variant');

			const settings: AutocompleteSettings<PlauditAutocompleteOption> = {
				className: variantClass,
				input: input,
				minLength: 0,
				showOnFocus: true,
				fetch: (text, update) => {
					$.ajax({
						dataType: "json",
						url: baseURI + 'core-api/suggester?suggester=' + encodeURI(suggester) + '&q=' + encodeURI(text),
						success: data => {
							mostRecentSuggestionsResponse = data;

							const flattenedResults: PlauditAutocompleteOption[] = [];

							for (const key in data) {
								if (data.hasOwnProperty(key)) {
									// iterate over each array and add to parent array
									const currentSuggester = data[key];
									for (let i = 0; i < currentSuggester.results.length; i++) {
										flattenedResults.push({
											...currentSuggester.results[i],
											group: singleSuggester ? null : key
										});
									}
								}
							}

							// Autocomplete plugin auto selects the first option. We do not want that so we add
							// a fake result at the beginning of the list.
							flattenedResults.unshift({} as PlauditAutocompleteOption);

							update(flattenedResults);
						},
						async: false
					});

				},
				onSelect: item => {
					onSelectedValidOption = item.href !== undefined;
					if (!onSelectedValidOption) {
						// Not a valid option
						return;
					}

					// Track use of auto-complete
					let label = item.label.replace(/<\/?span( [^>]*)?>/g, '');

					analytics.trackEvent('Search:' + suggester, 'Autocomplete Option Selected', input.value + " || " + label + " || " + item.href);

					// Change page to what was selected
					let href = item.href;
					if (!new RegExp('^(?:[a-z]+:)?//', 'i').test(href)) {
						const bases = document.getElementsByTagName('base');
						if (!bases || bases.length < 1) {
							href = item.href
						} else {
							const base: HTMLBaseElement = bases[0];
							href = base.href;
							if (href.charAt(href.length - 1) !== '/') {
								href = href + '/';
							}
							href = href + item.href;
						}
					}
					location.href = href;
				},
				renderGroup: (name: string, currentValue: string) => {
					const div = document.createElement("div");
					div.className = 'autocomplete__divider autocomplete__divider--' + name;
					const span = document.createElement("span");
					div.appendChild(span);
					span.innerText = (mostRecentSuggestionsResponse as any)[name].label !== undefined ? (mostRecentSuggestionsResponse as any)[name].label : name;
					return div;
				},
				render: (item, currentValue) => {
					// Add data to the display
					const div = document.createElement("div");
					div.className = 'autocomplete__option';

					// Add product image if it exists, else add styleclass for icon
					let productImageURL = Object(item.fields)['image'];
					if (typeof productImageURL !== 'undefined' && productImageURL !== null) {
						const img = document.createElement("img");
						img.src = productImageURL;

						const imgWrap = document.createElement('div')
						imgWrap.className = 'autocomplete__imgWrap';
						div.appendChild(imgWrap);
						imgWrap.appendChild(img);
					} else {
						div.className = 'autocomplete__option suggestion'
					}

					const labelWrapper = document.createElement("div");
					div.appendChild(labelWrapper);
					labelWrapper.innerHTML += item.label + (!!item.fields ? '<br/><span class="autocomplete__subtext">' + (item.fields as any)['propertyAddress'] + '</span>' : ''); // Note that 'label' is html

					return div;
				},
				debounceWaitMs: 250,
				emptyMsg: 'No immediate matches were found.'
			};

			require('autocompleter')(settings);

			input.addEventListener('keypress', evt => {
				// This prevents submission of the form when results are present.
				// Their implementation always prevents form submission regardless of the presence of results.
				if (onSelectedValidOption && evt.key === 'Enter' && document.body.querySelector('.autocomplete .empty') === null) {
					evt.preventDefault();
				}
			});

			input.classList.add('autocomplete-set-up');
		}
	};

	setUpElements(document.body);

	new MutationObserver(event => {
		for (let mutationRecord of event) {
			if (!!mutationRecord.addedNodes) {
				setUpElements(document.body);
				return;
			}
		}
	}).observe(document.body, { childList: true, subtree: true });
}
